// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyANeEKtEaTXZbPaodl5vUx-yihpRw1OXCg",
  authDomain: "buyoung2-7e805.firebaseapp.com",
  databaseURL: "https://buyoung2-7e805-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: "buyoung2-7e805",
  storageBucket: "buyoung2-7e805.firebasestorage.app",
  messagingSenderId: "791425565281",
  appId: "1:791425565281:web:6368470fc0a42aff122020",
  measurementId: "G-87PTRNFV21"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
export default app;